import GET_ARTICLES from '../plugins/getArticles'
import CONTENT_HEADER from '../plugins/content_header';
const [w,l] = [window,location]

const init = () => {

  const url = l.search ? l.pathname+l.search : l.pathname+'?mode=detail&article=1'
  $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999,url})

  GET_ARTICLES('.p-company-info [data-plugin="getArticles"]',{
    makeItem(item){
      return $(`
      <a href="${item.href}" class="p-company-info__item">
        <span class="date">${item.date}</span>
        <p class="title">${item.title}</p>
      </a>
      `)[0]
    }
  })

}

export default function ABOUT () {
  $(() => {
    if( $('[data-load-html="about-1-company"]').length ) {
      w.load['about-1-company'].done( init );
    } else {
      init();
    }

    CONTENT_HEADER()
  })
}